import { useState,useEffect,useRef } from 'react';
import styles from './TaskAdd.module.css';
import EmptyModal from '../../compoenets/EmptyModal'
import useApi from '../../services/useApi';

const Spinner = ({ size = 16, color = 'white' }) => {
    const strokeWidth=size/4;
    const radius=20;
    const viewBoxSize=50;

    return (
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
          className={styles['spinner']}
        >
          <circle
            cx="25"
            cy="25"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={Math.PI * radius * 0.2}
            strokeDashoffset="0"
          />
        </svg>
    );
};

export default function TaskAdd({testsetList,onChange,onClose}){
    const [uploadErr,setUploadErr] = useState(false);
    const [uploadMsg,setUploadMsg]=useState("");
    const inputRef=useRef(null);
    const [inputValue,setInputValue]=useState('');
    const [searchStatus,setSearchStatus]=useState('do');
    const [roundData,setRoundData]=useState([])
    const [dataset,setDataset]=useState(testsetList[0]);

    const handleUpload = async () => {
        useApi.post('backboard/task-evaluation',{
            userId:JSON.parse(localStorage.getItem("account")).id,
            taskId:inputValue,
            datasetId:dataset.datasetId,
        }).then((res)=>{
        //   setUploadMsg("Success");
          onChange();
          onClose();
        })
        .catch(async (err) => {
        });
    };

    useEffect(()=>{
        if(!inputRef.current)return;
        inputRef.current.focus();

        const handleInputKeyDown=(e)=>{
            if(e.key ==='Escape'){
                onClose();
            }
        }

        document.addEventListener("keydown", handleInputKeyDown);
        return () => {
          document.removeEventListener("keydown", handleInputKeyDown);
        };
    },[])

    useEffect(()=>{
        if(inputValue===null||inputValue===''){
            setSearchStatus('do')
            return;
        }

        setSearchStatus('doing')
        const handler=setTimeout(()=>{
            useApi.get('backboard/model/playground/flcore/'+inputValue+'/rounds').then((res)=>{
                if(res.data.data){
                    setRoundData(res.data.data);
                    setSearchStatus('done')
                }else{
                    setSearchStatus('fail')
                }
            }).catch(function (thrown) {
                setSearchStatus('fail')
            });
        },150)

        return()=>{
            clearTimeout(handler);
        }
    },[inputValue])

    useEffect(()=>{
        if(searchStatus==='done'||searchStatus==='fail'){
            if(inputValue===null||inputValue===''){
                setSearchStatus('do');
            }
        }

    },[searchStatus])

    const handleInputChange=(event)=>{
        if(event.key==='Escape')onClose();
        setInputValue(event.target.value);
    }

    useEffect(()=>{
        let timer;
        if(uploadErr){
            timer=setTimeout(() => {
                setUploadErr(false);
            }, 1200);
        }
        return()=>{
            clearTimeout(timer);
        }
    },[uploadErr])
    
    return(
        <EmptyModal onClose={()=>onClose()}>
            <div className={styles['wrap']}>
                <header>
                    <span>Add Task</span>
                    <button
                    className={`
                    ${styles['header-btn']} 
                    ${uploadMsg.includes('Success')&&styles['header-btn-success']}
                    ${uploadMsg.includes('Fail')&&styles['header-btn-fail']}
                    `}
                    onClick={onClose}
                    />
                </header>
                <div className={styles['main']}>
                    <div className={styles['body']}>
                        {searchStatus==='doing'?
                        <Spinner/>
                        :
                        <div className={`
                            ${styles['status']}
                            ${styles['status-' + searchStatus]}
                        `}/>}
                        <input 
                        ref={inputRef}
                        placeholder='Task ID를 입력해 주세요.'
                        value={inputValue}
                        onChange={handleInputChange} 
                        />
                        {inputValue!==''&&<button 
                        className={styles['input-clear']}
                        onClick={()=>setInputValue('')}/>}

                    </div>
                    <div className={styles['body-dropdown']}>
                        {dataset?.datasetName}
                    </div>
                </div>
                <footer>
                    <button className={`
                      ${styles["btn-upload"]} 
                      ${uploadErr&&styles['btn-upload-err']}
                      ${searchStatus==='done'&&styles['btn-upload-avail']}
                      `} 
                      onClick={handleUpload}
                    />
                </footer>
            </div>
        </EmptyModal>
    )
}